import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit } from "@mui/icons-material";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, FormActions, sortFunctions } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";














const schema = yup.object({
  nit: yup.string().required(),
  razon_social:yup.string().required(),
  nombre_comercial:yup.string().required(),
  cod_erp:yup.string().required(),
  configuracion:yup.string().required().test(
    "is_json",
    "No es un objeto valido",
    function(item){
       try{
        JSON.parse(item);
        return true;
       }catch(e){
        return false;
       }
    }
 ),
 }).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestroCompanias = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isvisibleModal,setIsvisibleModal] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [sortQuery,setSortQuery] = useState({});


    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{

      if ( Object.keys(sortQuery).length > 0 ){
        console.log({sortQuery});
        let sortedItems = [];
        if (sortQuery.dataType === 'string'){
          sortedItems  = [...sortFunctions.sortString(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }else{
          sortedItems  = [...sortFunctions.sortNumber(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }
        setDataSetProductos(sortedItems);
      }
     

    },[sortQuery]);

    useEffect(()=>{
      setSortQuery({});
      loadProducts( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.get("maestros/listar-companias",/* {
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     } */);
     setDataSetProductos([...value]);

     setTotalRows(10);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
      
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsvisibleModal(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      
      setProductoSeleccionado(product || {});
    }
    const onCloseModalDetalle = ()=>{
      setIsvisibleModal(false);
    }
    const setSortLabel = (key,dataType)=>{
       setSortQuery({
        key:key,
        sortValue:sortQuery.key === key?(sortQuery.sortValue === 'ASC'?'DESC':"ASC"):"ASC",
        dataType
       });
    }
    
    const onSaveDataForm = async (typeAction, dataForm) => {
      console.log({dataForm});

      setIsvisibleModal(false);

        dispatch({
          type: ActionTypes.setLoadingPage,
          data: true
        });
      let payload = {...dataForm};

    
        AxiosInstance.post("maestros/crear-editar-compania" , payload)
        .then( ({data})=>{
          loadProducts();
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Proceso exitoso",
                message:"",
                type:DialogType.exitoso,
                isVisible:true
            }
          });
        } ).catch(error=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"accion no realizada",
                type:DialogType.peligro,
                isVisible:true
            }
          });

        }).finally(()=>{
          dispatch({
            type: ActionTypes.setLoadingPage,
            data: false
          });
        });
           
           
            
    }
  
    const columnsTable = [
      {
      
        key:"cod",
        keyValue:"cod",
        label:"ID",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"nit",
        keyValue:"nit",
        label:"NIT",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"RAZON SOCIAL",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_comercial",
        keyValue:"nombre_comercial",
        label:"NOMBRE COMERCIAL",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      
       {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"ESTADO",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      
     {
      
        key:"cod",
        keyValue:"cod",
        label:"EDITAR",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button size="small" onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       }
     
        
    ];


    const configModal = {
      titleModal:'Configurar Compañia',
      buttomsAction:[
        {
          title: "Cancelar",
          buttomProps: {
    
            type: "buttom",
            color: "secondary",
            onClick: () => setIsvisibleModal(false)
          }
        },
        {
          title: "Guardar cambios",
          color: "primary",
          buttomProps: {
            type: "submit",
            //  onClick:onSaveModData
          }
        }
    
      ],
      imputs: [
 
        {
           key:"nit",
           keyValue:"nit",
           label:"NIT",
           component:InputWithLabel,
           inputProps:{
            size:"small"
          }
          
         },
         {
          key:"razon_social",
          keyValue:"razon_social",
          label:"RAZON SOCIAL",
          component:InputWithLabel,
          inputProps:{
            size:"small"
          }
        },
        {
          key:"nombre_comercial",
          keyValue:"nombre_comercial",
          label:"NOMBRE COMERCIAL",
          component:InputWithLabel,
          inputProps:{
            size:"small"
          }
        },

        {
          key:"cod_erp",
          keyValue:"cod_erp",
          label:"CODIGO ERP",
          component:InputWithLabel,
          inputProps:{
            size:"small"
          }
        },
        {
          key:"ind_estado",
          keyValue:"ind_estado",
          label:"ESTADO",
          component:SelectInputWithLabel,
         
          inputProps:{
            size:"small",
            items:[
              {
                label:"HABILITADO",
                value:"HABILITADO"
              },
              {
                label:"DESHABILITADO",
                value:"DESHABILITADO"
              }
            ],
          }
        },
       
        {
          key:"configuracion",
          keyValue:"configuracion",
          label:"Configuracion",
          responsiveSize:12,
          component:InputWithLabel,
          inputProps:{
            size:"small",
            multiline:true,
            rows:4
          }
        },
       
    
      ],
      arrayInputs:[]
    };
    

    return (<>
{
    isvisibleModal &&
    <ModalFormGenerador
      isVisible={isvisibleModal}
      schemaValidator={schema}
      entityValues={productoSeleccionado}
      {
      ...configModal
      }
      onSendForm={onSaveDataForm}
      typeAction={FormActions.MODIFICAR}
    />
  }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar proveedor"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
            <Button onClick={e=>{
              setProductoSeleccionado({});
              setIsvisibleModal(true)
              }} variant="contained" size="small" >Nueva compañia</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender {...colum} label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}